const matchesElement = (el, text) => (el.dataset.label || el.textContent || "").toLocaleLowerCase().startsWith(text);
class ElementFocusListItem {
    node;
    index;
    constructor(node, index) {
        this.node = node;
        this.index = index;
    }
    focus() {
        this.node.focus();
    }
    get isTabbable() {
        return this.node.tabIndex > -1;
    }
    setTabbable(isTabbable) {
        this.node.setAttribute("tabindex", isTabbable ? "0" : "-1");
    }
    has(element) {
        return this.node === element;
    }
    matches(text) {
        return matchesElement(this.node, text);
    }
}
class GroupFocusListItem {
    node;
    index;
    childNodes = [];
    constructor(node, index) {
        this.node = node;
        this.index = index;
    }
    addChildNode(node) {
        this.childNodes.push(node);
    }
    focus() {
        this.childNodes[0]?.focus();
    }
    has(element) {
        return this.childNodes.includes(element);
    }
    matches(text) {
        return matchesElement(this.childNodes[0], text);
    }
    get isTabbable() {
        return this.childNodes[0].tabIndex > -1;
    }
    setTabbable(isTabbable) {
        this.childNodes.forEach((node) => node.setAttribute("tabindex", isTabbable ? "0" : "-1"));
    }
}
export function createFocusListItemsLinear(nodes) {
    return Array.prototype.map.call(nodes, (node, index) => new ElementFocusListItem(node, index++));
}
export function createFocusListItemsGrouped(nodes, groupingSelector) {
    const result = [];
    let index = 0;
    let lastGroup = null;
    for (const node of nodes) {
        const groupRoot = node.closest(groupingSelector);
        if (!lastGroup || groupRoot !== lastGroup.node) {
            lastGroup && result.push(lastGroup);
            lastGroup = (groupRoot && new GroupFocusListItem(groupRoot, index++)) ?? null;
        }
        if (lastGroup && groupRoot === lastGroup.node && !lastGroup.has(node)) {
            lastGroup.addChildNode(node);
        }
        if (!groupRoot) {
            result.push(new ElementFocusListItem(node, index++));
            continue;
        }
    }
    if (lastGroup) {
        result.push(lastGroup);
    }
    return result;
}
export function createFocusListItems(nodes, groupingSelector) {
    if (groupingSelector !== undefined) {
        return createFocusListItemsGrouped(nodes, groupingSelector);
    }
    return [...createFocusListItemsLinear(nodes)];
}
